import SupplierRow from './SupplierRow.jsx';

export default function SupplierList({ suppliers }) {
  if (!suppliers.length) {
    return <p className="supplier-message">No suppliers match this category.</p>;
  }

  return (
    <div className="RadGrid RadGrid_MetroTouch">
      <table className="rgMasterTable supplierGuide">
        <tbody>
          {suppliers.map((supplier, index) => (
            <SupplierRow
              key={`${supplier.Company ?? 'supplier'}-${supplier.WorkPhone ?? ''}-${index}`}
              supplier={supplier}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
